import { useEffect, useState } from "react";

/**
 * useScrollDeep — returns true when the page is scrolled past the given
 * progress ratio (0..1) of the scrollable area. Used by floating action
 * buttons to swap visibility deep into the page.
 */
export function useScrollDeep(threshold = 0.45) {
  const [deep, setDeep] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const docEl = document.documentElement;
      const scrollable =
        (docEl.scrollHeight || document.body.scrollHeight) - window.innerHeight;
      if (scrollable <= 0) return setDeep(false);
      setDeep(window.scrollY / scrollable > threshold);
    };
    onScroll();
    const t = setTimeout(onScroll, 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [threshold]);

  return deep;
}
